import { render, staticRenderFns } from "./DatabaseCopy.vue?vue&type=template&id=552e2274&scoped=true"
import script from "./DatabaseCopy.vue?vue&type=script&lang=js"
export * from "./DatabaseCopy.vue?vue&type=script&lang=js"
import style0 from "./DatabaseCopy.vue?vue&type=style&index=0&id=552e2274&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552e2274",
  null
  
)

export default component.exports